module.exports = "/lucky-balls/video/regular_game.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/video/regular_game.mp4
// module id = 879
// module chunks = 0